import { render, staticRenderFns } from "./country-index.vue?vue&type=template&id=12cc8f60"
import script from "./country-index.vue?vue&type=script&lang=js"
export * from "./country-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports